import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUser = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.25 15.25C14.25 11.7983 11.4517 9 8 9C4.54822 9 1.75 11.7983 1.75 15.25M8 6.5C9.44975 6.5 10.625 5.32475 10.625 3.875C10.625 2.42525 9.44975 1.25 8 1.25C6.55025 1.25 5.375 2.42525 5.375 3.875C5.375 5.32475 6.55025 6.5 8 6.5Z",
		stroke: "currentColor",
		strokeWidth: 1.5
	})
});
export default SvgUser;
